<template>
    <section id="explore_area" class="section_padding">
        <div class="container">
            <div class="row" id="target-div">
                <div class="col-lg-3">
                    <div v-if="allData?.data?.length > 0" class="left_side_search_area relative">
                        <div v-if="show_next_btn || this.tripType == 'multi_city'" class="disable"></div>
                        <div v-if="is_self_paying == 1" class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Filter by price') }}</h5>
                            </div>
                            <div class="filter-price">
                                <Slider v-model="price_rang" :min="min" :max="max"
                                    @change="filterFlights($event, 'price')"
                                    :direction="this.$i18n.locale == 'ar' ? 'rtl' : 'ltr'" />
                                <div class="d-flex justify-content-between mt-3">
                                    <small>{{ min }} {{ $t('SAR') }}</small>
                                    <small>{{ max }} {{ $t('SAR') }}</small>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.tripType != 'multi_city'" class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Number of stops') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div v-for="(item, index) in stops" :key="item" class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span v-if="item == 1">{{ $t('Non-stop') }}</span>
                                            <span v-else>{{ item - 1 }} {{ $t('Stop') }}</span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" :id="'stops-' + index" type="checkbox"
                                                    @change="filterFlights(index, 'stops')"
                                                    v-model="departureStops[index]" style="display: none">
                                                <label class="cbx" :for="'stops-' + index">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Airlines') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div v-for="(item, index) in airlines" :key="item.en" class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>
                                                {{ $i18n.locale === 'en' ? item.en : item.ar }}
                                                <span v-if="trusted_partners.includes(item.code)"
                                                    style="color: #8354A3;font-weight: 700;">
                                                    ({{ $t('Trusted partner') }})
                                                </span>
                                            </span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" :id="'airlines-' + index" type="checkbox"
                                                    v-model="departureAirlines[index]"
                                                    @change="filterFlights(index, 'airlines')"
                                                    :disabled="Object.keys(airlines).length == 1 || this.departure_selecting == 0 ? true : false"
                                                    style="display: none">
                                                <label class="cbx" :for="'airlines-' + index">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Departure time') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>12:00 MN - 4:59 AM</span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" id="times-0" type="checkbox"
                                                    v-model="departureTimes[0]" @change="filterFlights(0, 'times')"
                                                    style="display: none">
                                                <label class="cbx" for="times-0">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>05:00 AM - 11:59 AM</span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" id="times-1" type="checkbox"
                                                    v-model="departureTimes[1]" @change="filterFlights(1, 'times')"
                                                    style="display: none">
                                                <label class="cbx" for="times-1">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>12:00 NN - 4:59 PM</span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" id="times-2" type="checkbox"
                                                    v-model="departureTimes[2]" @change="filterFlights(2, 'times')"
                                                    style="display: none">
                                                <label class="cbx" for="times-2">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>05:00 PM - 11:59 PM</span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" id="times-3" type="checkbox"
                                                    v-model="departureTimes[3]" @change="filterFlights(3, 'times')"
                                                    style="display: none">
                                                <label class="cbx" for="times-3">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Baggage') }}</h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <span class="area_flex_one">
                                            <span>
                                                {{ $t('Flights include baggage only') }}
                                            </span>
                                            <div class="ripple-checkbox-primary">
                                                <input class="inp-cbx" id="with-bags-only" type="checkbox"
                                                    v-model="withBagsOnly" @change="filterFlights(0, 'bags')"
                                                    style="display: none">
                                                <label class="cbx" for="with-bags-only">
                                                    <span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                            </polyline>
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.departure_selecting == 1 && this.tripType != 'multi_city'"
                            class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>{{ $t('Journey Duration') }}</h5>
                            </div>
                            <div class="filter-price">
                                <Slider v-model="departure_duration_rang" :min="minDepartureDuration"
                                    :max="maxDepartureDuration" @change="filterFlights($event, 'duration')"
                                    :direction="this.$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                                    :format="formatDurationSlider" />
                                <div class="d-flex justify-content-between mt-3">
                                    <small>{{ formatDuration(minDepartureDuration) }}</small>
                                    <small>{{ formatDuration(maxDepartureDuration) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="left_side_search_area skeleton">
                        <div v-if="is_self_paying == 1" class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                        <div v-for="i in 3" class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div v-for="i in 5" class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                        <div v-if="this.tripType != 'multi_city'" class="left_side_search_boxed">
                            <div class="left_side_search_heading">
                                <h5>
                                    <lv-skeleton :width="200" :height="15" />
                                </h5>
                            </div>
                            <div class="tour_search_type">
                                <div class="form-check">
                                    <lv-skeleton :width="200" :height="15" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div v-if="allData?.data?.length > 0" class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="section_heading_center">
                                <h2 v-if="departure_selecting == 1">
                                    {{ $t('Flights Found') }}
                                    ({{ result?.data?.length }})
                                </h2>
                                <h2 v-else>{{ $t('Summary of your flight order') }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="this.tripType != 'multi_city'" class="col-lg-12" id="departure-result">
                            <div v-if="allData?.data?.length > 0"
                                class="flight_search_result_wrapper flight-result-con">
                                <flight-item v-if="goFlight == null" v-for="item in result.data" :item="item" :type="0"
                                    :result="result" :is_selected="false" :trusted_partners="trusted_partners"
                                    :allowed_to_make_exception="allowed_to_make_exception"
                                    :is_self_paying="is_self_paying" :user_type="user_type"
                                    :max_ticket_price="max_ticket_price" @select_flight="select_flight">
                                </flight-item>
                            </div>
                            <div v-else class="flight_search_result_wrapper skeleton">
                                <flight-skeleton-item v-for="item in 10"></flight-skeleton-item>
                            </div>
                            <div v-if="goFlight != null" class="selected-flight">
                                <div class="mb-3 plr-40">
                                    <img src="@/assets/img/svg/img_icon_flighttake_off.svg" width="35">
                                    <div class="inline-middle pl-3 pr-3">
                                        <h4 class="new-bold-light bold mb-1">{{ $t('Departure Flight') }}</h4>
                                        <span class="dep-date font-14">
                                            {{ getFormattedDate(this.searchData.date) }}
                                        </span>
                                    </div>
                                </div>
                                <flight-item :item="goFlight" :type="0" :result="result" :is_selected="true"
                                    :trusted_partners="trusted_partners"
                                    :allowed_to_make_exception="allowed_to_make_exception"
                                    :max_ticket_price="max_ticket_price" @change_flight="change_flight">
                                </flight-item>
                            </div>
                            <div v-if="showMoreOptions" class="col-lg-12">
                                <div class="load-more">
                                    <button type="button" @click="load_more_options">
                                        {{ $t('Load More Options With') }} {{ this.stops[1] - 1 }} {{ $t('Stop') }}
                                    </button>
                                </div>
                            </div>
                            <div v-else-if="result?.data?.length == 0" class="col-lg-12">
                                <div class="no-flights">
                                    <h3>{{ $t('No Flights matched on criteria') }}</h3>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.tripType == 'roundtrip' && this.departure_selecting == 0" class="col-lg-12"
                            id="arrival-result">
                            <h4 v-if="arrival_selecting == 1" class="no-margin text-center mb-3 ml5 mr5 count-arrival">
                                <span class="new-bold-dark font-20 arrival">{{ $t('Return Flight') }}</span>
                                <span v-if="this.departure_selecting == 0" class="flight-count new-bold-dark"> ({{ count
                                    }}) </span>
                                <span v-if="this.departure_selecting == 0" class="flight-count new-bold-dark">{{
                                    $t('Results') }}</span>
                            </h4>
                            <div class="flight_search_result_wrapper flight-result-con">
                                <flight-item v-if="returnFlight == null" v-for="item in arrival_results" :item="item"
                                    :type="1" :result="result" :is_selected="false" :trusted_partners="trusted_partners"
                                    :allowed_to_make_exception="allowed_to_make_exception"
                                    :is_self_paying="is_self_paying" :user_type="user_type"
                                    :max_ticket_price="max_ticket_price" @select_flight="select_flight">
                                </flight-item>
                            </div>
                            <div v-if="returnFlight != null" class="selected-flight">
                                <div class="mb-3 plr-40">
                                    <img src="@/assets/img/svg/img_icon_flightlanding.svg" width="35">
                                    <div class="inline-middle pl-3 pr-3">
                                        <h4 class="new-bold-light bold mb-1">{{ $t('Return flight') }}</h4>
                                        <span class="dep-date font-14">
                                            {{ getFormattedDate(this.searchData.ret_date) }}
                                        </span>
                                    </div>
                                </div>
                                <flight-item :item="returnFlight" :type="1" :result="result" :is_selected="true"
                                    :trusted_partners="trusted_partners"
                                    :allowed_to_make_exception="allowed_to_make_exception"
                                    :is_self_paying="is_self_paying" :max_ticket_price="max_ticket_price"
                                    @change_flight="change_flight">
                                </flight-item>
                            </div>
                            <div v-if="arrival_results?.length == 0" class="col-lg-12">
                                <div class="no-flights">
                                    <h3>{{ $t('No Flights matched on criteria') }}</h3>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.tripType == 'multi_city'" class="col-lg-12" id="departure-result">
                            <div v-if="allData?.data?.length > 0"
                                class="flight_search_result_wrapper flight-result-con">
                                <flight-mulit-item v-if="goFlight == null" v-for="item in result.data" :item="item"
                                    :type="0" :result="result" :is_selected="false" :trusted_partners="trusted_partners"
                                    :allowed_to_make_exception="allowed_to_make_exception"
                                    :max_ticket_price="max_ticket_price" :is_self_paying="is_self_paying"
                                    :user_type="user_type" @select_flight="select_flight">
                                </flight-mulit-item>
                            </div>
                            <div v-else class="flight_search_result_wrapper skeleton">
                                <flight-mulit-skeleton-item v-for="item in 10"></flight-mulit-skeleton-item>
                            </div>
                            <div v-if="goFlight != null" class="selected-flight">
                                <flight-mulit-item :item="goFlight" :result="result" :is_selected="true"
                                    @change_flight="change_flight">
                                </flight-mulit-item>
                            </div>
                            <div v-if="result?.data?.length == 0" class="col-lg-12">
                                <div class="no-flights">
                                    <h3>{{ $t('No Flights matched on criteria') }}</h3>
                                </div>
                            </div>
                        </div>
                        <div v-if="show_next_btn" class="col-lg-12  text-right price-fl">
                            <button class="btn btn-fa-primary  p15 btn-block w-30  pull-right" @click="add_passenger">
                                <span class="no-margin bold">{{ $t('next') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery';
import { toast } from 'vue3-toastify';
import Slider from '@vueform/slider';
import LvSkeleton from 'lightvue/skeleton';
import airlinesData from '@/assets/file/airlines.json';
import flightsService from '@/services/jsky/flights/flights-service';
import FlightItem from './FlightItem.vue';
import FlightSkeletonItem from './FlightSkeletonItem.vue';
import FlightMulitSkeletonItem from './FlightMulitSkeletonItem.vue';
import FlightMulitItem from './FlightMulitItem.vue';
import { formatDuration, isTimeInRange, parseDurationToMinutes } from '@/utils/timeUtils';
import { formatDate } from '@/utils/dateUtils';
export default {
    name: "SearchResult",
    components: {
        Slider,
        LvSkeleton,
        FlightItem,
        FlightSkeletonItem,
        FlightMulitItem,
        FlightMulitSkeletonItem
    },
    data() {
        return {
            result: [],
            arrival_results: [],
            date: '',
            ret_date: '',
            airlines: [],
            allData: [],
            count: 0,
            stops: [],
            searchData: [],
            tripType: '',
            departure_selecting: 1,
            arrival_selecting: 1,
            selected_airline: null,
            max_ticket_price: 50000,
            allowed_to_make_exception: 0,
            is_self_paying: 0,
            user_type: null,
            trusted_partners: ['EK'],
            goFlight: null,
            returnFlight: null,
            show_next_btn: false,
            departureTimes: [true, true, true, true,],
            departureStops: [],
            departureAirlines: [],
            max: 0,
            min: 0,
            price_rang: [0, 100],
            departure_duration_rang: [0, 100],
            minDepartureDuration: 0,
            maxDepartureDuration: 0,
            showMoreOptions: false,
            withBagsOnly: true,
            includedCarrierCodes: ["EK", "SV", "RJ", "GF", "TK", "EY", "WY", "KU", "QR", "BA", "LH", "AF", "FZ", "CX"]
        }
    },
    methods: {
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        formatDurationSlider(value) {
            return formatDuration(value, 1, this.$i18n.locale);
        },
        formatDuration(duration) {
            return formatDuration(duration, 0, this.$i18n.locale);
        },
        getUniqueSegmentLengths(flightOffers) {
            const uniqueSegmentLengths = new Set();
            flightOffers.forEach((offer) => {
                if (this.departure_selecting == 1) {
                    offer.itineraries.forEach((itinerary, index) => {
                        if (index == 0) {
                            uniqueSegmentLengths.add(itinerary.segments.length);
                        } else {
                        }
                    });
                } else {
                    offer.itineraries.forEach((itinerary, index) => {
                        if (index == 1) {
                            uniqueSegmentLengths.add(itinerary.segments.length);
                        }
                    });
                }
            });
            return Array.from(uniqueSegmentLengths);
        },
        add_passenger() {
            window.location = `/flight-passengers`;
        },
        select_flight(details, type, need_approval) {
            if (this.tripType == 'roundtrip') {
                if (type == 0) {
                    this.showMoreOptions = false;
                    if (need_approval == true) {
                        localStorage.setItem('need_approval', 1);
                    } else {
                        localStorage.setItem('need_approval', 0);
                    }
                    this.departure_selecting = 0;
                    this.stops = this.getUniqueSegmentLengths(this.allData.data).sort(function (a, b) {
                        return a - b;
                    });
                    this.departureStops.forEach((element, index) => {
                        if (index == 0) {
                            this.departureStops[index] = true;
                        } else {
                            this.departureStops[index] = false;
                        }
                    });
                    this.departureTimes.forEach((element, index) => {
                        this.departureTimes[index] = true;
                    });
                    this.price_rang = [this.min, this.max];
                    localStorage.setItem('departure_flight', JSON.stringify(details));
                    var airline = details.validatingAirlineCodes[0];
                    this.selected_airline = airline;
                    var array = [this.stops[0]];
                    this.arrival_results = this.allData.data.filter((flight) => {
                        if (array.includes(flight.itineraries[1].segments.length) && flight.validatingAirlineCodes.includes(airline)) {
                            return true;
                        }
                        return false;
                    });

                    //filter flights
                    const filteredFlights = {};
                    this.arrival_results.forEach(flight => {
                        const key = `${flight.itineraries[1].segments[0].departure.iataCode}-` +
                            `${flight.itineraries[1].segments[0].arrival.iataCode}-` +
                            `${flight.itineraries[1].segments[0].departure.at}-` +
                            `${flight.itineraries[1].segments[flight.itineraries[1].segments.length - 1].arrival.at}`;

                        if (!filteredFlights[key] || parseFloat(flight.price.total) < parseFloat(filteredFlights[key].price.total)) {
                            filteredFlights[key] = flight;
                        }
                    });
                    this.arrival_results = Object.values(filteredFlights);
                    //

                    this.count = this.arrival_results.length;
                    this.goFlight = details;
                    if (this.count == 0) {
                        this.departureStops[1] = true;
                    }
                    this.filterFlights(0, 'bags');
                    setTimeout(() => {
                        $("html, body").animate({
                            scrollTop: $("#arrival-result").offset().top - 200
                        }, 10);
                    }, 100);
                } else {
                    if (need_approval == true) {
                        localStorage.setItem('need_approval', 1);
                    }
                    localStorage.setItem('arrival_flight', JSON.stringify(details));
                    this.arrival_selecting = 0;
                    this.show_next_btn = true;
                    this.returnFlight = details;
                    setTimeout(() => {
                        $("html, body").animate({
                            scrollTop: $("#arrival-result").offset().top - 370
                        }, 10);
                    }, 100);
                }
            } else {
                if (need_approval == true) {
                    localStorage.setItem('need_approval', 1);
                } else {
                    localStorage.setItem('need_approval', 0);
                }
                localStorage.removeItem("arrival_flight");
                localStorage.setItem('departure_flight', JSON.stringify(details));
                this.departure_selecting = 0;
                this.show_next_btn = true;
                this.goFlight = details;
                setTimeout(() => {
                    $("html, body").animate({
                        scrollTop: $(".section_heading_center").offset().top - 150
                    }, 10);
                }, 100);
            }
        },
        change_flight(type) {
            if (this.tripType == 'multi_city') {
                this.show_next_btn = false;
                this.goFlight = null;
                this.departure_selecting = 1;
                localStorage.setItem('need_approval', 0);
            } else {
                if (type == 'departure') {
                    localStorage.setItem('need_approval', 0);
                    this.departure_selecting = 1;
                    this.arrival_selecting = 1;
                    this.stops = this.getUniqueSegmentLengths(this.allData.data).sort(function (a, b) {
                        return a - b;
                    });
                    this.count = this.result.data.length;

                    this.departureStops.forEach((element, index) => {
                        if (index != 0) {
                            this.departureStops[index] = false;
                        }
                    });
                    this.departureAirlines.forEach((element, index) => {
                        this.departureAirlines[index] = true;
                    });
                    this.departureTimes.forEach((element, index) => {
                        this.departureTimes[index] = true;
                    });
                    this.price_rang = [this.min, this.max];
                    this.departure_duration_rang = [
                        this.minDepartureDuration,
                        this.maxDepartureDuration,
                    ];
                    this.filterFlights(0, 'stops');

                    if (this.result.data.length < 5) {
                        this.showMoreOptions = true;
                    }

                    this.withBagsOnly = true;
                    this.show_next_btn = false;
                    this.returnFlight = null;
                    this.goFlight = null;
                    this.filterFlights(0, 'bags');
                } else {
                    this.arrival_selecting = 1;
                    this.show_next_btn = false;
                    this.returnFlight = null;
                }
            }
        },
        isTimeInRange(timeString, timeRange) {
            return isTimeInRange(timeString, timeRange);
        },
        calculateFinalPrice(ticketPrice, maxTicketPrice) {
            var is_self_paying = localStorage.getItem("is_self_paying");
            const margin = is_self_paying == 0 ? 0.30 : 0;
            let finalPrice = ticketPrice * (1 + margin);
            if (finalPrice > maxTicketPrice) {
                finalPrice = maxTicketPrice;
            }
            return parseFloat(finalPrice.toFixed(2));
        },
        getFareDetailsBySegmentId(travelerPricings, segmentId) {
            var travelerPricing = travelerPricings[0].fareDetailsBySegment.filter(item => {
                return item.segmentId == segmentId;
            })[0];
            if (travelerPricing.includedCheckedBags.quantity != null) {
                return travelerPricing.includedCheckedBags.quantity > 0;
            } else {
                return travelerPricing.includedCheckedBags.weight > 0;
            }
        },
        filterFlights(index, type) {
            var stopsRange = [];
            var departureTimeRange = [];
            var airlineCodes = [];

            this.departureStops.forEach((element, index) => {
                if (element) {
                    stopsRange.push(this.stops[index]);
                }
            });
            this.departureAirlines.forEach((element, index) => {
                if (element) {
                    airlineCodes.push(this.airlines[index].code);
                }
            });
            if (this.departureTimes[0] == true) {
                departureTimeRange.push({ 'from': '00:00', 'to': '04:59' });
            }
            if (this.departureTimes[1] == true) {
                departureTimeRange.push({ 'from': '05:00', 'to': '11:59' });
            }
            if (this.departureTimes[2] == true) {
                departureTimeRange.push({ 'from': '12:00', 'to': '16:59' });
            }
            if (this.departureTimes[3] == true) {
                departureTimeRange.push({ 'from': '17:00', 'to': '23:59' });
            }

            // Filter flights
            if (this.departure_selecting == 1) {
                var result = this.allData.data.filter((flight) => {
                    var stopsCondition = stopsRange.includes(flight.itineraries[0].segments.length);
                    var airlineCondition = flight.validatingAirlineCodes.some(code => airlineCodes.includes(code));
                    // Check price condition
                    if (type == 'price') {
                        var priceCondition = this.calculateFinalPrice(parseFloat(flight.price.total)) >= index[0] &&
                            this.calculateFinalPrice(parseFloat(flight.price.total)) <= index[1];
                    } else {
                        var priceCondition = this.calculateFinalPrice(parseFloat(flight.price.total)) >= this.price_rang[0] &&
                            this.calculateFinalPrice(parseFloat(flight.price.total)) <= this.price_rang[1];
                    }

                    // Get departure time and check range
                    var departureTime = flight
                        .itineraries[0].segments[0].departure.at
                        .substring(11, 16);
                    var departureTimeCondition = departureTimeRange.some(range => this.isTimeInRange(departureTime, range));

                    // Get departure duration and check range
                    const firstItineraryDuration = this.parseDurationToMinutes(flight.itineraries[0].duration);
                    if (type == 'duration') {
                        var departureDurationCondition =
                            firstItineraryDuration >= index[0] &&
                            firstItineraryDuration <= index[1];
                    } else {
                        var departureDurationCondition =
                            firstItineraryDuration >= this.departure_duration_rang[0] &&
                            firstItineraryDuration <= this.departure_duration_rang[1];
                    }
                    var baggages = true;
                    if (this.withBagsOnly) {
                        baggages = this.getFareDetailsBySegmentId(flight.travelerPricings, flight
                            .itineraries[0].segments[0].id);
                    }
                    return stopsCondition && airlineCondition && priceCondition && departureTimeCondition && departureDurationCondition && baggages;
                });
                if (result.length == 0 && !['duration', 'price'].includes(type)) {
                    switch (type) {
                        case 'stops':
                            this.departureStops[index] = true;
                            break;
                        case 'times':
                            this.departureTimes[index] = true;
                            break;
                        case 'airlines':
                            this.departureAirlines[index] = true;
                            break;
                        case 'bags':
                            this.withBagsOnly = false;
                            break;
                        default:
                            break;
                    }
                    toast.error(this.$t('There are no matching flights'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                this.count = result.length;
                this.result.data = result;
            } else {
                const filteredFlights = {};
                this.allData.data.forEach(flight => {
                    const key = `${flight.itineraries[1].segments[0].departure.iataCode}-` +
                        `${flight.itineraries[1].segments[0].arrival.iataCode}-` +
                        `${flight.itineraries[1].segments[0].departure.at}-` +
                        `${flight.itineraries[1].segments[flight.itineraries[1].segments.length - 1].arrival.at}`;

                    if (!filteredFlights[key] || parseFloat(flight.price.total) < parseFloat(filteredFlights[key].price.total)) {
                        filteredFlights[key] = flight;
                    }
                });
                var result = Object.values(filteredFlights).filter((flight) => {
                    var stopsCondition = stopsRange.includes(flight.itineraries[1].segments.length);
                    var airlineCondition = flight.validatingAirlineCodes.includes(this.selected_airline);
                    // Check price condition
                    if (type == 'price') {
                        var priceCondition = this.calculateFinalPrice(parseFloat(flight.price.total)) >= index[0] &&
                            this.calculateFinalPrice(parseFloat(flight.price.total)) <= index[1];
                    } else {
                        var priceCondition = this.calculateFinalPrice(parseFloat(flight.price.total)) >= this.price_rang[0] &&
                            this.calculateFinalPrice(parseFloat(flight.price.total)) <= this.price_rang[1];
                    }
                    // Get departure time and check range
                    var departureTime = flight
                        .itineraries[1].segments[0].departure.at
                        .substring(11, 16);
                    var departureTimeCondition = departureTimeRange.some(range => this.isTimeInRange(departureTime, range));

                    var baggages = true;
                    if (this.withBagsOnly) {
                        baggages = this.getFareDetailsBySegmentId(flight.travelerPricings, flight
                            .itineraries[1].segments[0].id);
                    }

                    return stopsCondition && airlineCondition && priceCondition && departureTimeCondition && baggages;
                });
                if (result.length == 0 && !['duration', 'price'].includes(type)) {
                    switch (type) {
                        case 'stops':
                            this.departureStops[index] = true;
                            break;
                        case 'times':
                            this.departureTimes[index] = true;
                            break;
                        case 'airlines':
                            this.departureAirlines[index] = true;
                            break;
                        case 'bags':
                            this.withBagsOnly = false;
                        default:
                            break;
                    }
                    toast.error(this.$t('There are no matching flights'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                this.count = result.length;
                this.arrival_results = result;
            }
        },
        parseDurationToMinutes(duration) {
            return parseDurationToMinutes(duration);
        },
        load_more_options() {
            this.showMoreOptions = false;
            this.departureStops[1] = true;
            this.filterFlights(1, 'stops');
        }
    },
    mounted() {
        localStorage.setItem("is_bags_confirmed", false);
        var targetTop = $("#target-div").offset().top;
        this.tripType = localStorage.getItem("tripType");
        this.is_self_paying = localStorage.getItem("is_self_paying");
        this.user_type = localStorage.getItem("user_type");
        this.allowed_to_make_exception = localStorage.getItem("allowed_to_make_exception");
        var can_request_help = localStorage.getItem("can_request_help"),
            allowed_to_choose_need_help_option = localStorage.getItem("allowed_to_choose_need_help_option");
        var scroll = 0;
        if (allowed_to_choose_need_help_option == 0 || can_request_help == 'false') {
            scroll = -50;
        }
        if (this.tripType != 'multi_city') {
            $("html, body").animate({ scrollTop: targetTop + scroll + 110 }, 'slow');
        } else {
            $("html, body").animate({ scrollTop: targetTop + scroll + 225 }, 'slow');
        }
        if (localStorage.getItem("guest_id") || localStorage.getItem("user_token")) {
            if (localStorage.getItem("searchData")) {
                this.searchData = JSON.parse(localStorage.getItem("searchData"));
                var ticket_price = JSON.parse(localStorage.getItem("max_ticket_price"));
                if (ticket_price.length > 0) {
                    if (this.searchData.cabin == 'ECONOMY') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.ticket_type === 'Economy');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    } else if (this.searchData.cabin == 'BUSINESS') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.ticket_type === 'Business');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    } else if (this.searchData.cabin == 'FIRST') {
                        var cabin_price = ticket_price.filter(ticketClass => ticketClass.ticket_type === 'First Class');
                        if (cabin_price.length > 0) {
                            this.max_ticket_price = parseFloat(cabin_price[0]['ticket_price']);
                        }
                    }
                }
                if (this.is_self_paying == 1) {
                    this.max_ticket_price = 500000000;
                }
                localStorage.setItem("max_price", this.max_ticket_price);

                var guest_data = JSON.parse(localStorage.getItem("guest_data"));

                // guest_data.policy.airlines.forEach(element => {
                //     this.includedCarrierCodes.push(element.airline.airline_code);
                // });

                var from = this.searchData.from;
                var to = this.searchData.to;
                var date = this.searchData.date;
                var ret_date = this.searchData.ret_date;
                var maxPrice = this.allowed_to_make_exception == 0 ?
                    this.max_ticket_price : "";

                if (this.tripType == 'multi_city') {
                    var params = new URLSearchParams(this.searchData.info);
                    from = JSON.stringify(params.getAll('from[]'));
                    to = JSON.stringify(params.getAll('to[]'));
                    date = JSON.stringify(params.getAll('date[]'));
                }
                var body = {
                    currency: this.searchData.currency,
                    from: from,
                    to: to,
                    date: date,
                    ret_date: this.tripType == 'roundtrip' ? ret_date : null,
                    adults: this.searchData.adults,
                    children: this.searchData.children,
                    infants: this.searchData.infants,
                    cabin: this.searchData.cabin,
                    nonStop: false,
                    maxPrice: maxPrice,
                    max: 250,
                    type: this.tripType,
                    includedCarrierCodes: this.includedCarrierCodes
                };
                flightsService.get_flight_offers(body).then((response) => {
                    this.departureStops = [];
                    this.departureAirlines = [];
                    const data = response.data.data;
                    this.result = data;
                    this.allData = Object.assign([], data);
                    this.count = data.data.length;
                    this.airlines = data.airlines;
                    if (this.result.data.length == 0) {
                        toast.error(this.$t('There are no flights available'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 2500);
                    } else {
                        const allDurations = [];
                        const airlines = new Set();
                        let min = Infinity;
                        let max = -Infinity;
                        data.data.forEach(element => {
                            allDurations.push(this.parseDurationToMinutes(element.itineraries[0].duration));
                            element.itineraries[0].segments.forEach(segments => {
                                airlinesData[segments.carrierCode]['code'] = segments.carrierCode;
                                airlines.add(airlinesData[segments.carrierCode]);
                            });
                            if (min > parseFloat(element.price.grandTotal)) {
                                min = parseFloat(element.price.grandTotal);
                            }
                            if (max < parseFloat(element.price.grandTotal)) {
                                max = parseFloat(element.price.grandTotal);
                            }
                        });
                        this.max = this.calculateFinalPrice(max);
                        this.min = this.calculateFinalPrice(min);
                        this.price_rang = [
                            this.min,
                            this.max
                        ];

                        this.minDepartureDuration = Math.min(...allDurations);
                        this.maxDepartureDuration = Math.max(...allDurations);
                        this.departure_duration_rang = [
                            this.minDepartureDuration,
                            this.maxDepartureDuration,
                        ];

                        this.airlines = Array.from(airlines);
                        this.airlines.forEach(element => {
                            this.departureAirlines.push(true);
                        });
                        this.stops = this.getUniqueSegmentLengths(data.data).sort(function (a, b) {
                            return a - b;
                        });
                        this.stops.forEach((element, index) => {
                            this.departureStops.push(index == 0 ? true : false);
                        });
                        if (this.tripType != 'multi_city') {
                            var array = [this.stops[0]];
                            const filteredFlights = this.allData.data.filter((flight) => {
                                if (array.includes(flight.itineraries[0].segments.length)) {
                                    return true;
                                }
                                return false;
                            });
                            if (filteredFlights.length < 5) {
                                this.showMoreOptions = true;
                            }
                            this.count = filteredFlights.length;
                            this.result.data = filteredFlights;
                        }
                        this.filterFlights(0, 'bags');
                    }
                }).catch(error => {
                    toast.error(this.$t('An error occurred, try again'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 2500);
                });
            }
        } else {
            $('.pre-loader').hide();
            this.$router.replace(`/error`);
        }
    },
};
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss" scoped>
@media (min-width: 1200px)
{
    .container, .container-lg, .container-md, .container-sm, .container-xl {
        max-width: 1290px;
    }
}
.section_padding {
    background: #fcfcfc;
    padding: 65px 0;
}

.flight_inner_show_component {
    justify-content: center;
}

.airline-details {
    justify-content: flex-start;
}

.flight_show_down_wrapper {
    padding-top: 25px;
    padding-bottom: 25px;
}


.disable {
    position: absolute;
    width: calc(100% - 0px);
    height: calc(100% - 0px);
    background-color: rgb(137 137 137 / 8%);
    z-index: 8;
    cursor: not-allowed;
    margin-left: 0px;
    transition: 0.3s;
    left: 0px;
    border-radius: 8px;
}

.price-fl .txt-price {
    font-size: 1.75rem;
}
.col-md-offset-8 {
    margin-left: 63.64%;
    margin-right: 0;
}
.rtl .col-md-offset-8 {
    margin-right: 63.64%;
    margin-left: 0;
}

.new-bold-dark {
    font-weight: 400;
    color: var(--main-color);
}

.btn-fa-primary {
    background-color: var(--main-color);
    border: 0;
    color: #fff;
    outline: 0;
    box-shadow: none;
    border-radius: 5px;
    transition: .3s;
    margin-top: 10px;

    &:hover {
        background-color: var(--black-color);
    }
}

.btn-block {
    display: block;
    width: 100%;
}

.p15 {
    padding: 15px !important;
}
</style>
<style lang="scss">
.flight_logo {
    width: 92px;
    text-align: -webkit-center;
}

.area_flex_one span {
    font-weight: 500;
    padding-top: 5px;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 180px;
}


.pl0 {
    padding-left: 0 !important;
}

.mt20 {
    margin-top: 20px !important;
}

.p15 {
    padding: 15px !important;
}

.rtl{
    .skeleton {
        .flight_right_arrow img {
            rotate: 180deg;
        } 
        .flight_search_right {
            border-right: 1px solid #edf1f3;
            border-left: none;
        }
    }
}
.skeleton {
    .flight_search_right {
        background: #f3eff900;
        padding: 25px 16px 20px 25px;
        border-left: 1px solid #edf1f3;
    }

    .flight-image {
        filter: grayscale(95%) brightness(175%);
    }

    .left_side_search_heading h5 {
        padding-bottom: 20px;
        text-align: center;
    }

    .filter-price {
        padding-top: 15px;
        padding-bottom: 0px;
        text-align: center;
    }

    .tour_search_type .form-check {
        text-align: center;
        padding-left: 0px;
    }
}
.tour_search_type .form-check {
    padding-left: 0px;
}
.rtl .multi_city {
    .multi_city_flight_lists {
        border-left: 1px dashed #ddd;

        .itineraries {
            padding: 18px 25px;
            border-bottom: 1px dashed #ddd;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .flight_search_right {
        background: #fff;
    }
    .flight_right_arrow img{
        width:50px;
        height:50px;
    }
}
.multi_city {
    .multi_city_flight_lists {
        border-right: 1px dashed #ddd;

        .itineraries {
            padding: 18px 25px;
            border-bottom: 1px dashed #ddd;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .flight_search_right {
        background: #fff;
    }
    .flight_right_arrow img{
        width:50px;
        height:50px;
    }
}
.cbx span:first-child {
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    transform: scale(1);
    vertical-align: middle;
    border: 1px solid #9098A9;
    transition: all 0.2s ease;
}
.cbx span {
    display: inline-block;
}
.cbx span:first-child:before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    transform: scale(0);
    opacity: 1;
    border-radius: 50%;
}
.ripple-checkbox-primary .cbx span:first-child:before {
    background: var(--main-color)  !important;
}
.cbx span:first-child svg {
    position: absolute;
    top: 3px;
    left: 2px;
    fill: none;
    stroke: #FFFFFF;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.3s ease;
    transition-delay: 0.1s;
    transform: translate3d(0, 0, 0);
}
.ripple-checkbox-primary .inp-cbx:checked + .cbx span:first-child {
    background: var(--main-color) ;
    border-color: var(--main-color) ;
    animation: wave 0.4s ease;
}
.ripple-checkbox-primary .inp-cbx:disabled:checked + .cbx span:first-child {
    opacity: 0.6;
    cursor: not-allowed;
}
.inp-cbx:checked + .cbx span:first-child:before {
    transform: scale(3.5);
    opacity: 0;
    transition: all 0.6s ease;
}
.inp-cbx:checked + .cbx span:first-child svg {
    stroke-dashoffset: 0;
}
@keyframes wave {
    50% {
        transform: scale(0.9);
    }
}
.no-flights{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    min-height: 300px;
}
.plr-40{
    padding: 0px 40px;
}
.load-more{
    button{
        background: var(--main-color);
        border: none;
        border-radius: 5px;
        width: 100%;
        padding: 14px 0px;
        font-size: 14px;
        color: #fff;
    }
}
</style>